// extracted by mini-css-extract-plugin
module.exports = {"logo":"Header_logo__AMaZ1","link":"Header_link__Y-i5l","link--active":"Header_link--active__2tTnW"};